import { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { textWithShowMoreMessages } from './messages'
import {
  TextWithShowMoreBody,
  TextWithShowMoreButton,
  TextWithShowMoreButtonWrapper,
  TextWithShowMoreContainer,
} from './styles'

interface TextWithShowMoreProps {
  text: string
  shortTextLettersAmount?: number
}

const DEFAULT_SHORT_TEXT_LETTERS_AMOUNT = 310

function TextWithShowMore({
  text,
  shortTextLettersAmount = DEFAULT_SHORT_TEXT_LETTERS_AMOUNT,
}: TextWithShowMoreProps) {
  const [showMore, setShowMore] = useState(false)
  const isTextShort = text.length < shortTextLettersAmount

  return (
    <TextWithShowMoreContainer>
      <TextWithShowMoreBody>
        {isTextShort || showMore
          ? text
          : `${text.substring(0, shortTextLettersAmount)}...`}
      </TextWithShowMoreBody>
      <TextWithShowMoreButton onClick={() => setShowMore(!showMore)}>
        {!isTextShort && (
          <TextWithShowMoreButtonWrapper>
            {showMore ? (
              <FormattedMessage {...textWithShowMoreMessages.showLess} />
            ) : (
              <FormattedMessage {...textWithShowMoreMessages.showMore} />
            )}
          </TextWithShowMoreButtonWrapper>
        )}
      </TextWithShowMoreButton>
    </TextWithShowMoreContainer>
  )
}

export default TextWithShowMore
